export default "__VITE_ASSET__0k6jzm5b__"